<div class="bpx-dialog">
  <h2 mat-dialog-title>Non-Latest Revision Selected</h2>
  <mat-dialog-content>
    You selected revision <strong>{{ data.selectedRevision }}</strong>.
    The latest revision is <strong>{{ data.latestRevision }}</strong>.
    Do you want to proceed with the older revision?
  </mat-dialog-content>
  <mat-dialog-actions>
    <button matRipple class="bpx-btn bpx-btn--primary" (click)="confirm()">Confirm</button>
    <button matRipple class="bpx-btn" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
